import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';

@Component({
  selector: 'app-upload-csv-button',
  templateUrl: './upload-csv-button.component.html',
})
export class UploadCsvButtonComponent {
  @ViewChild('csvUploaderInput') private csvUploaderInput: ElementRef;
  @Input() buttonText: string;
  @Input() disabled: boolean;
  @Output() afterAddingFile = new EventEmitter();

  onAfterAddingFile(uploadEvent: any) {
    const csvFile = uploadEvent?.target?.files[0];
    if (!csvFile) {
      return;
    }
    this.afterAddingFile.emit(csvFile);
  }

  openFileInput() {
    this.csvUploaderInput.nativeElement.click();
  }
}
